import React from 'react';
import { BlogArticleTemplate } from '../../components/blog/BlogArticleTemplate';
import { withoutInsuranceArticle } from '../../data/blog/withoutInsuranceArticle';
export function WithoutInsuranceArticle() {
  return <BlogArticleTemplate article={withoutInsuranceArticle} data-id="element-808" data-mp="2chfwubc0kw82" />;
}